import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button } from '@mui/material';

import SimPopupBox from 'components/SimPopupBox';
import SimContainer from 'components/SimContainer';

import tn1 from 'assets/images/popup/tn1.jpg';
import tn2 from 'assets/images/popup/tn2.jpg';
import tn3 from 'assets/images/popup/tn3.jpg';
import tn4 from 'assets/images/popup/tn4.jpg';
import tn5 from 'assets/images/popup/tn5.jpg';
import tn6 from 'assets/images/popup/tn6.jpg';
import tn7 from 'assets/images/popup/tn7.jpg';
import tn8 from 'assets/images/popup/tn8.jpg';
import youtubeLogo from 'assets/images/popup/Youtube_logo.png';

const SimPopupWithDiscount = ({ index, srcLink }) => {
	const [open, setOpen] = useState(false);

	const currentTn = () => {
		switch (index) {
			case 0:
				return tn1;

			case 1:
				return tn2;

			case 2:
				return tn3;

			case 3:
				return tn4;

			case 4:
				return tn5;

			case 5:
				return tn6;

			case 6:
				return tn7;

			case 7:
				return tn8;

			default:
				return 'DEFAULT';
		}
	};

	return (
		<SimContainer display={'flex'} justifyContent={'center'} alignItems={'center'} paddingX={'auto'}>
			<Box borderRadius={'20px'}>
				<Box width={1}>
					<Box
						display={'flex'}
						justifyContent={'center'}
						alignItems={'center'}
						paddingX={'auto'}
						sx={{
							backgroundImage: `url(${currentTn()})`,
							backgroundRepeat: 'no-repeat',
							backgroundSize: 'cover',
							width: { xs: '70vw', sm: '22vw', md: '22vw' },
							height: { xs: '39.37vw', sm: '16.2vw', md: '16.2vw' },
							borderRadius: { xs: '2vw', sm: '2vw', md: '1.5vw' }
						}}
						onClick={() => setOpen(true)}>
						<Box
							display={'flex'}
							justifyContent={'center'}
							alignItems={'center'}
							padding={'auto'}
							sx={{
								backgroundImage: `url(${youtubeLogo})`,
								backgroundRepeat: 'no-repeat',
								backgroundSize: 'contain',
								width: { xs: '6.2vw', sm: '6vw', md: '6vw' },
								height: { xs: '7.9vw', sm: '3.36vw', md: '3.36vw' },
								marginLeft: { xs: '4vw', sm: '2vw', md: '2vw' }
							}}>
							<Button
								color={'primary'}
								size={'large'}
								fullWidth
								display={'flex'}
								sx={{
									fontWeight: 700,
									width: '9.0vw',
									height: '5vw',
									alignSelf: 'center'
								}}
								onClick={() => setOpen(true)}></Button>
						</Box>
					</Box>

					<SimPopupBox
						srcTitle='YouTube video player'
						srcLink={srcLink}
						open={open}
						onClose={() => setOpen(false)}
					/>
				</Box>
			</Box>
		</SimContainer>
	);
};

SimPopupWithDiscount.propTypes = {
	index: PropTypes.number.isRequired,
	srcLink: PropTypes.string.isRequired
};

export default SimPopupWithDiscount;
